export default __webpack_public_path__ + "static/thumb-landscape-623db314ed83c19747a839dbadebd46f.jpg";